module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12"
  }, [_c('va-box', {
    attrs: {
      "title": "Printer History Records",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    staticClass: "box-tools",
    staticStyle: {
      "float": "right",
      "padding": "0px 10px"
    },
    attrs: {
      "slot": "icon-title"
    },
    slot: "icon-title"
  }, [_c('div', {
    staticStyle: {
      "padding-left": "0px",
      "padding-bottom": "10px",
      "border-radius": "5px"
    }
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', [_vm._v("From Date:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.fromDate),
      expression: "filters.fromDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filters.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "fromDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', [_vm._v("To Date:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.toDate),
      expression: "filters.toDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "min": "filters.toDate"
    },
    domProps: {
      "value": (_vm.filters.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "toDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "padding-top": "22px"
    }
  }, [_c('ul', {
    staticClass: "pagination pagination-sm inline",
    staticStyle: {
      "cursor": "pointer",
      "vertical-align": "bottom"
    }
  }, [_c('li', {
    class: [_vm.options.activeFilter === 'Counters' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Counters'
      }
    }
  }, [_vm._v("Counters")])]), _vm._v(" "), _c('li', {
    class: [_vm.options.activeFilter === 'Toners' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Toners'
      }
    }
  }, [_vm._v("Toners")])]), _vm._v(" "), _c('li', {
    class: [_vm.options.activeFilter === 'Info' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Info'
      }
    }
  }, [_vm._v("Info")])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "col-lg-2 col-md-4 col-sm-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("Printer Info:")])]), _vm._v(" "), _vm._l((_vm.printerInfo), function(item) {
    return _c('div', {
      staticClass: "printerInfoItem"
    }, [_c('span', {
      staticClass: "description-text"
    }, [_vm._v(_vm._s(item.title) + ":")]), _vm._v(" "), _c('b', {
      staticClass: "text-right pull-right"
    }, [_vm._v(_vm._s(item.value))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-8 col-sm-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("Toner Replace:")])]), _vm._v(" "), _c('VueTable', {
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "columns": _vm.columnsToner,
      "rows": _vm.tonerHistory,
      "pageSize": 100
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-8 col-sm-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("Printer History:")])]), _vm._v(" "), _c('VueTable', {
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.printerHistory,
      "pageSize": 100,
      "options": _vm.options
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    class: [_vm.isFullScreenChart ? 'col-lg-12' : 'col-lg-6', 'col-md-12 col-sm-12']
  }, [_c('va-box', {
    attrs: {
      "title": "Counters History",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": _vm.isFullScreenChart ? 'window-restore' : 'window-maximize'
    },
    on: {
      "windowClicked": function($event) {
        _vm.isFullScreenChart = !_vm.isFullScreenChart
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-chart', {
    attrs: {
      "chart-config": _vm.countersChart
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    class: [_vm.isFullScreenChart ? 'col-lg-12' : 'col-lg-6', 'col-md-12 col-sm-12']
  }, [_c('va-box', {
    attrs: {
      "title": "Toners History",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": _vm.isFullScreenChart ? 'window-restore' : 'window-maximize'
    },
    on: {
      "windowClicked": function($event) {
        _vm.isFullScreenChart = !_vm.isFullScreenChart
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-chart', {
    attrs: {
      "chart-config": _vm.tonersChart
    }
  })], 1)])], 1)]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": _vm.isFullpage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09307043!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PrinterHistory.vue
// module id = 666
// module chunks = 0